import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
import {pagination, modal} from "../../../app/services/dataTemplates"

const ReportsModule = () => {
  return {
    state: {
      loaded: false,
      collection: [],
      pagination: Object.assign({}, pagination),
    },
    mutations,
    actions,
    getters,
  }
};

export default ReportsModule;



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/reports/index.js